module.exports = __webpack_public_path__ + "resources/img/img_hi_psm_m_jp.c9706dcfed115bbb443a14e7d4822f54.png";